import { useState } from 'react';

import type { SelectOption } from '~/components/Forms/Select';
import Select from '~/components/Forms/Select';

import type { SubscriberPreference } from '~/interfaces/subscriber_preferences';

import PreferenceDescription from './PreferenceDescription';
import PreferenceName from './PreferenceName';

interface Props {
  preference: SubscriberPreference;
  onChange: (value: string) => void;
}

const DropdownField = ({ preference, onChange }: Props) => {
  const [selectedValue, setSelectedValue] = useState<SelectOption>(
    preference.value ? { name: preference.value, value: preference.value } : {},
  );

  const handleChange = (newOption: SelectOption) => {
    setSelectedValue(newOption);
    onChange(newOption.value || '');
  };

  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex flex-col gap-y-0.5">
        <PreferenceName name={preference.name} />
        <PreferenceDescription description={preference.description} />
      </div>
      <div className="w-96">
        <Select
          onChange={handleChange}
          selectedValue={selectedValue}
          options={preference.subscriber_preference_options.map((option) => ({
            name: option.value,
            value: option.value,
          }))}
          placeholder="Select option"
        />
      </div>
    </div>
  );
};

export default DropdownField;
